<template>
  <transition name="modal">
    <div class="modal-mask position-fixed">
      <div class="modal-container relative">
        <div class="modal-tabs">
          <BaseButton class="modal-close" aria-label="Close modal" @click="$emit('close')">×</BaseButton>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div v-if="controls" class="modal-controls">
          <BaseButton @click="$emit('yes')">Yes</BaseButton>
          <BaseButton @click="$emit('close')">No</BaseButton>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    props: {
      controls: {type: Boolean, default: false},
    },
  }
</script>
